import {createContext, useState, useRef} from "react";
const SiteContext = createContext();


export const SiteProvider = ({children}) => {

    let fetched = useRef(false)
    const userTypingSpeed = 60;
    const bastTypingSpeed = 50;

    const fetchData = async () => {
            if(!fetched.current){
                try {
                        // const response = await fetch(`${process.env.REACT_APP_BASEURL}/data`, { mode: 'cors' });
                        const response = await fetch(`${process.env.REACT_APP_BASEURL}/data`);
                        const data = await response.json();
                        await addData(data)

                    //
                }
                catch (e) {
                    console.log(e)
                }
            }


    }

    const addData = async (newData) => {
        if (initialIndustriesState.length === 0) {
            fetched.current = true;
            initialIndustriesState = newData
            setIndustries(initialIndustriesState)
        }

    }

    const removeSentFlags = () => {
        setIndustries(prevState => {
            return prevState.map(industry => {
                return {...industry, messages: industry.messages.map(message => {
                        return {...message, sent: false}
                    })}
            })
        })
    }



    let initialIndustriesState = []

    const [industries, setIndustries] = useState([])
    const [menuOpen, setMenuOpen] = useState(false)



    const [currentIndustryIndex, setCurrentIndustryIndex] = useState(0)

    const changeCurrentIndustry = async (index) => {
        //setIndustries(() => initialIndustriesState);
        removeSentFlags();
        setCurrentIndustryIndex(index);
        setCurrentMessageIndex(-1);
    }



    const [currentMessageIndex, setCurrentMessageIndex] = useState(-1)

    const updateCurrentMessageIndex = async () => {

        const newMessageIndex = currentMessageIndex + 1;
        if(industries[currentIndustryIndex].messages[newMessageIndex]){
            setCurrentMessageIndex(newMessageIndex);
            if(industries[currentIndustryIndex].messages[newMessageIndex]?.user !== "bast") {
                setCurrentMessageSent(false)
            }
        }else{
            setTimeout(() => {
                const newCurrentIndustryIndex = currentIndustryIndex + 1
                if(industries[newCurrentIndustryIndex]){
                     changeCurrentIndustry(newCurrentIndustryIndex)
                }else{
                     changeCurrentIndustry(0)
                }
            }, 2000)

        }

    }




    const updateCurrentMessageSent = async () => {
        setIndustries((prevState) => {
            const newState = [...prevState];
            newState[currentIndustryIndex].messages[currentMessageIndex].sent = true;
            return newState;
        })
        setCurrentMessageSent(true)
    }

    const [currentMessageSent, setCurrentMessageSent] = useState(true);



    return (
        <SiteContext.Provider value={{
            industries,
            currentIndustryIndex,
            changeCurrentIndustry,
            currentMessageIndex,
            currentMessageSent,
            menuOpen,
            setMenuOpen,
            userTypingSpeed,
            bastTypingSpeed,
            updateCurrentMessageSent,
            updateCurrentMessageIndex,
            fetchData
        }}>
            {children}
        </SiteContext.Provider>
    )
}

export default SiteContext;
